import type React from 'react'

import { SkeletonBlock } from './SkeletonBlock'

interface SkeletonFieldProps {
  className?: string
}

export const SkeletonField: React.FC<SkeletonFieldProps> = ({ className = '' }) => (
  <div className={`space-y-2 ${className}`.trim()}>
    <SkeletonBlock className="h-4 w-40" />
    <SkeletonBlock className="h-10 w-full" />
  </div>
)
